import type { FormEvent } from 'react';
import { APP_COPYRIGHT_NOTICE } from '@ferty9/constants';
import { EyeIcon, EyeOffIcon } from './icons';

export function SurveyLoginForm({
  username,
  password,
  passwordVisible,
  error,
  loading,
  onUsernameChange,
  onPasswordChange,
  onTogglePassword,
  onSubmit,
  onForgotPassword,
}: {
  username: string;
  password: string;
  passwordVisible: boolean;
  error: string;
  loading: boolean;
  onUsernameChange: (value: string) => void;
  onPasswordChange: (value: string) => void;
  onTogglePassword: () => void;
  onSubmit: (event: FormEvent) => void;
  onForgotPassword: () => void;
}) {
  return (
    <div id="login-overlay" className="overlay show">
      <div className="auth-shell auth-shell-web"><aside className="auth-brand-panel"><img src="/logo.png" alt="Ferty9"/><div><span className="auth-eyebrow">FERTY9 CARE NETWORK</span><h1>Every patient journey, connected.</h1><p>A calm, secure workspace for centre teams delivering thoughtful fertility care.</p></div><small>Trusted care &bull; Connected teams &bull; Secure access</small></aside><main className="auth-form-panel" id="staff-login-area">
          <span className="auth-security-pill">Centre team portal</span><h1>Welcome</h1><p className="auth-intro">Sign in to continue to your Ferty9 workspace.</p>
          <form onSubmit={onSubmit}>
            <div className="input-group">
              <label>Username</label>
              <input type="text" id="login-username" name="username" autoComplete="username" placeholder="Enter username" required value={username} onChange={event => onUsernameChange(event.target.value)} />
            </div>
            <div className="input-group">
              <label>Password</label>
              <div style={{ position: 'relative' }}>
                <input type={passwordVisible ? 'text' : 'password'} id="login-password" name="password" autoComplete="current-password" placeholder="Enter password" required style={{ paddingRight: 60 }} value={password} onChange={event => onPasswordChange(event.target.value)} />
                <button type="button" onClick={onTogglePassword} style={{ position: 'absolute', right: 20, top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', background: 'none', border: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text-light)' }} id="pass-toggle" aria-label={passwordVisible ? 'Hide password' : 'Show password'}>
                  {passwordVisible ? <EyeIcon /> : <EyeOffIcon />}
                </button>
              </div>
            </div>
            <div id="login-error" style={{ color: 'var(--danger)', fontSize: 13, fontWeight: 600, marginBottom: 20, display: error ? 'block' : 'none' }}>{error}</div>
            <button type="button" className="auth-forgot-link" onClick={onForgotPassword}>Forgot password?</button><button type="submit" id="login-btn" className="btn btn-primary auth-submit" disabled={loading}>
              {loading ? 'Authenticating...' : 'Sign In'}
            </button>
            <p className="login-legal-notice">{APP_COPYRIGHT_NOTICE}</p>
            <nav className="login-policy-links" aria-label="Legal policies"><a href="/terms">Terms</a><a href="/privacy">Privacy</a><a href="/cookies">Cookies</a><a href="/compliance">Compliance</a><a href="/consent">Consent</a><a href="/data-retention">Retention</a></nav>
          </form>
        </main>
      </div>
    </div>
  );
}
